import { useQuery } from "@tanstack/react-query";
import { prependKasUrl, KAS_HOST } from "../utils";
import posthog from "posthog-js";
import { History } from "history";

type TokenResponse = {
  token: string;
  requestStatus: {
    statusCode: string;
  };
};

export const useGetStarfleetToken = (history: History<unknown>) => {
  const queryKey = "/token";
  return useQuery({
    queryFn: async (): Promise<TokenResponse> =>
      fetch(prependKasUrl(queryKey), {
        headers: { host: KAS_HOST },
        credentials: "include",
        method: "GET",
      })
        .then(async (response) => {
          const data = await response.json();
          if (!data?.token) {
            console.error("[kas] /token returned no token", {
              statusCode: data?.requestStatus?.statusCode,
            });
            posthog.capture("StarfleetTokenMissing", {
              statusCode: data?.requestStatus?.statusCode,
            });
          }
          return data;
        })
        .catch((error) => {
          console.error("Error fetching starfleet token:", error);
          posthog.capture("StarfleetTokenError", {
            response: error,
          });
          history.push("/logout");
          return undefined;
        }),

    queryKey: [queryKey],
    refetchInterval: 1000 * 60 * 14, // 10 minutes in milliseconds (ID token is expired at 15 mins)
    refetchIntervalInBackground: true, // ensure the ID token is refetched even when the tab/window is in the background - otherwise user may run into auth issues after minimizing the window and coming back.
    cacheTime: 0,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
};
